/**
 * The public menu — every string, and the one setting worth putting at the
 * top of a file.
 */

/**
 * Where the menu website lives.
 *
 * ── SET THIS ONCE, WHEN YOU KNOW THE DOMAIN ──────────────────────────────
 *
 * It is the only thing that decides what a printed QR code points at, and a
 * printed code cannot be changed afterwards — it is taped to a table. So
 * change it before printing the first one, and then leave it alone.
 *
 * No trailing slash. The link becomes `<this>/<publicBusinessId>`.
 */
export const MENU_SITE_URL = 'https://menu.dalabtire.com';

/** The link a customer's phone opens. */
export function menuLinkFor(publicBusinessId) {
  if (!publicBusinessId) return '';
  return `${MENU_SITE_URL.replace(/\/+$/, '')}/${publicBusinessId}`;
}

export const COPY = {
  /* the panel */
  title: 'Public menu',
  intro:
    'Download the code and put it on the tables. A customer points their camera at it and your menu opens on their phone — no app, no sign-in.',

  statusOn: 'Public menu is on',
  statusOff: 'Public menu is off',
  statusOnBody: 'Anyone who scans the code can read your menu.',
  statusOffBody:
    'The code will not open for anyone until you switch this on. Printed codes keep working — they point at the same address.',

  turnOn: 'Switch on',
  turnOff: 'Switch off',
  working: 'Saving…',

  /* before it has ever been switched on */
  notReadyTitle: 'Not set up yet',
  notReadyBody:
    'Dalabtire has to switch the public menu on for this shop once, which creates the permanent address the code points at. Ask us and it takes a minute.',

  /* the code */
  qrTitle: 'Your QR code',
  qrHint: 'Hold a phone camera up to the screen to test it.',
  linkLabel: 'Link',
  copyLink: 'Copy link',
  copied: 'Link copied',
  copyFailed: 'Could not copy — select the link and copy it by hand.',
  openLink: 'Open',
  download: 'Download QR code',
  downloaded: 'Saved to your downloads as a PNG',
  downloadFailed: 'Could not save the image. Try again.',

  /* what happens when the server says no */
  refusedTitle: 'Only Dalabtire can change this',
  refused:
    'The server would not let this account change it. Ask Dalabtire to switch the public menu on or off for you.',
  failed: 'Could not save that. Check the connection and try again.',
  savedOn: 'Public menu is now on',
  savedOff: 'Public menu is now off',
};

/** What the confirm dialog asks before the menu goes dark. */
export const CONFIRM_OFF = {
  title: 'Switch the public menu off?',
  confirmLabel: 'Switch off',
  body: 'Scanning the code will stop working for customers, straight away.',
  note:
    'The codes you have already printed are not wasted. The address never changes, so switching it back on makes every one of them work again.',
};
